import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactoryRushCapacitySlot from "./factory-rush-capacity-slot.model";

export default class FactoryRushCapacitySlotFactory
  implements ObjectBuilderInterface<FactoryRushCapacitySlot> {
  public buildFromJSON(data: { [key: string]: any }): FactoryRushCapacitySlot {
    const value = new FactoryRushCapacitySlot(
      data.id,
      data.factory,
      String(data.product),
      data.type,
      +data.capacity
    );

    (value as any).fCreatedAt = new Date(data.createdAt);
    (value as any).fUpdatedAt = new Date(data.updatedAt);

    value.isNew = false;

    return value;
  }
}
